import { Outlet, NavLink, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { DarkModeProvider } from '../DarkModeContext';
import DarkModeToggle from '../DarkModeToggle';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Layout() {
  const navItem = ({ isActive }) =>
    `flex-1 px-4 py-4 text-center text-sm font-medium transition-all duration-200 hover:bg-white/20 ${
      isActive ? 'bg-white/20 border-b-2 border-white' : ''
    }`;

  return (
    <DarkModeProvider>
      <div className="min-h-screen bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100">
        <ScrollToTop />
        <nav className="sticky top-0 z-50 text-white flex flex-wrap flex-row bg-gradient-to-r from-Template-0 to-Template-1 shadow-lg">
          <NavLink className={navItem} to="/">SmartDice</NavLink>
          <NavLink className={navItem} to="/soft">Software</NavLink>
          <NavLink className={navItem} to="/hard">Hardware</NavLink>
          <NavLink className={navItem} to="/app">App</NavLink>
          <NavLink className={navItem} to="/dicemould">Würfel gießen</NavLink>
          <NavLink className={navItem} to="/UeberUns">Über uns</NavLink>
          <DarkModeToggle />
        </nav>
        <Outlet />
      </div>
    </DarkModeProvider>
  );
}

export default Layout;
